/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Inviteuser1Inputs */

const en_btn_inviteuser1 = /** @type {(inputs: Btn_Inviteuser1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite user`)
};

/**
* | output |
* | --- |
* | "Invite user" |
*
* @param {Btn_Inviteuser1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_inviteuser1 = /** @type {((inputs?: Btn_Inviteuser1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Inviteuser1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_inviteuser1(inputs)
});
export { btn_inviteuser1 as "btn_inviteUser" }